const House = ({ className = "", color }: { className?: string; color: string }): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      data-name="layer1"
      d="M54 25.267l7.555 7.3a.25.25 0 0 1-.174.43H54V61H40V43H24v18H10V33H2.618a.25.25 0 0 1-.174-.43L32 4l13 12.567V11h9z"
      fill={color}
    ></path>
    <path
      data-name="opacity"
      d="M33 4.966L32 4 2.445 32.57a.25.25 0 0 0 .174.43H10v28h14V43h9z"
      fill="#000064"
      opacity=".15"
    ></path>
  </svg>
);

export default House;
